var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _rect2, _rect3, _rect4, _rect5, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 238,
    viewBox: "0 0 236 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 235,
    height: 235,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1221_38394)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22411 236.5H228.776C232.475 236.5 235.482 233.506 235.5 229.822V8.19625C235.5 4.49416 232.493 1.5 228.776 1.5H6.22411C2.50663 1.5 -0.5 4.49416 -0.5 8.19625V229.804C-0.5 233.506 2.50663 236.5 6.22411 236.5ZM224.093 119C224.093 177.63 176.366 225.158 117.491 225.158C58.6163 225.158 10.8891 177.63 10.8891 119C10.8891 60.3704 58.6163 12.8417 117.491 12.8417C176.366 12.8417 224.093 60.3704 224.093 119ZM22.5895 208.863H8.33804V214.524H22.5895V228.722H28.2747V214.524H42.5233V208.863H28.2747V194.679H22.5895V208.863ZM207.68 23.5845H193.424V29.2463H207.68V43.4215H213.365V29.2463H227.61V23.5845H213.365V9.37822H207.68V23.5845ZM227.555 228.207L196.886 220.005L219.3 197.684L223.418 212.946L227.555 228.207ZM27.107 14.6563L8.04625 9.53887L18.3057 47.5381L46.1862 19.7555L27.107 14.6563Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H48.5V29.5L7.5 56V7.5Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 8.5H229.5V43.5L207.5 45.5L191 36.5L192.5 8.5Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191 206.5L210.5 189.5L230.5 188.5V232.5H188.5L191 206.5Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 192.5H34.5L44.5 209.5L43.5 231.5H6.5V192.5Z",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1221_38394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 18,
    width: 201,
    height: 202
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 219.707C173.089 219.707 217.82 174.587 217.82 118.929C217.82 63.2706 173.089 18.1504 117.909 18.1504C62.7296 18.1504 17.998 63.2706 17.998 118.929C17.998 174.587 62.7296 219.707 117.909 219.707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1221_38394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.378 45.1645C106.576 48.0726 101.099 50.6882 95.7503 53.5231C67.4269 68.5578 41.5879 86.994 19.6473 110.661C8.04233 123.19 -2.22078 136.743 -8.33152 152.911C-10.5256 158.728 -11.3778 165.056 -12.8466 171.165C-12.9735 171.714 -13.0641 172.262 -13.173 172.811C-13.4268 172.866 -13.6807 172.902 -13.9345 172.957C-15.911 166.41 -18.2501 159.935 -19.7914 153.277C-28.2956 116.898 -23.6355 82.2565 -5.938 49.3712C-0.280592 38.8545 8.96708 33.7149 19.9193 30.9714C31.3972 28.0999 43.0566 28.2279 54.6978 29.5082C74.0453 31.6299 92.5589 37.1352 110.619 44.3049C111.072 44.4878 111.526 44.7439 112.378 45.1645Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.571 65.3574C251.312 70.8078 253.288 76.2034 254.721 81.7272C264.222 118.271 260.106 153.278 242.953 186.859C237.005 198.491 227.395 204.655 215.228 207.453C203.569 210.142 191.801 209.959 179.978 208.624C160.993 206.466 142.914 200.96 125.199 194.029C124.746 193.845 124.31 193.589 123.422 193.15C124.565 192.583 125.399 192.126 126.251 191.724C158.762 176.379 188.282 156.698 213.396 130.635C226.09 117.466 237.078 103.072 244.059 85.8974C246.579 79.7155 248.32 73.3321 248.682 66.6196C248.701 66.2358 248.81 65.8513 248.882 65.4675C249.118 65.4489 249.353 65.3941 249.571 65.3574Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.221 151.247C184.602 144.918 185.073 138.901 185.309 132.884C186.723 97.8581 183.278 63.4365 171.891 30.1301C166.904 15.5529 160.467 1.67077 150.331 -10.0714C146.813 -14.1501 142.443 -17.479 138.454 -21.137C138.11 -21.4479 137.71 -21.7222 137.348 -22.0149C137.42 -22.2161 137.493 -22.4355 137.565 -22.6367C142.407 -21.6491 147.303 -20.9174 152.071 -19.6554C189.153 -9.92512 217.857 11.4011 238.546 43.9208C245.673 55.1144 245.908 66.7103 242.137 78.8732C238.057 91.9872 230.822 103.308 222.445 113.99C211.637 127.781 198.963 139.633 185.363 150.552C185.11 150.735 184.82 150.881 184.221 151.247Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0528 87.4697C50.7627 100.84 49.9829 114.21 50.2731 127.562C50.944 157.649 55.3865 187.114 66.4295 215.281C71.9963 229.474 79.068 242.826 90.1105 253.599C92.649 256.068 95.5143 258.208 98.7237 260.915C95.6954 260.439 93.1209 260.146 90.5818 259.616C49.2758 250.8 17.616 228.176 -4.32459 191.796C-10.4897 181.554 -9.80068 170.653 -6.46424 159.752C-2.34813 146.291 5.15881 134.695 13.8081 123.812C24.4702 110.369 36.9093 98.7182 50.2368 88.037C50.5813 87.7441 50.944 87.5431 51.0528 87.4697Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0918 161.087C63.1117 165.093 68.6426 168.97 74.3725 172.555C100.048 188.668 127.229 201.325 156.695 208.66C173.195 212.757 189.896 214.915 206.922 213.122C214.847 212.281 222.444 210.269 229.879 206.977C228.011 209.245 226.215 211.549 224.275 213.744C201.573 239.332 173.449 255.08 139.831 260.42C131.636 261.719 123.186 261.939 114.863 261.774C107.065 261.609 100.61 257.421 94.8801 252.3C84.7261 243.246 78.1077 231.705 72.6859 219.414C65.0884 202.148 60.5188 184.004 57.7445 165.367C57.5269 164.087 57.3456 162.788 57.0918 161.087Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48438 31.4291C14.2089 20.6745 23.511 11.566 34.1005 3.79276C58.1626 -13.8755 85.1259 -22.9473 114.846 -23.8618C125.163 -24.1727 133.776 -20.4598 141.283 -13.6194C150.948 -4.82184 157.403 6.22534 162.68 18.0041C170.114 34.6664 174.72 52.1883 177.584 70.204C177.947 72.454 178.31 74.7033 178.745 77.3918C173.433 73.8256 168.591 70.4417 163.623 67.2773C139.053 51.603 113.087 39.0012 84.9628 31.2096C67.7911 26.4542 50.3656 23.6558 32.4867 24.7898C24.2001 25.3202 16.1491 27.0394 8.51522 30.478C7.82621 30.8072 7.15532 31.1181 6.48438 31.4291Z",
    fill: "#282828"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.909 64.7715L142.044 106.93L166.161 149.071H117.909H69.6582L93.7925 106.93L117.909 64.7715Z",
    stroke: "#282828",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.37 116.844H106.469V121.014H129.37V116.844Z",
    fill: "#282828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.982 130.493V107.393H115.848V130.493H119.982Z",
    fill: "#282828"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 207.863,
    y: 8.79297,
    width: 6.19914,
    height: 34.5504,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 228.182,
    y: 22.959,
    width: 6.21908,
    height: 34.4397,
    transform: "rotate(90 228.182 22.959)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2324,
    y: 194.675,
    width: 6.19914,
    height: 34.5504,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.551,
    y: 208.841,
    width: 6.21908,
    height: 34.4397,
    transform: "rotate(90 42.551 208.841)",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41182 9.61785L46.0813 19.7528L18.122 47.5118L8.41182 9.61785Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.121 228.128L190.399 218.19L218.214 190.285L228.121 228.128Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1221_38394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 237,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2d0b06526f0ede3a385ae6578d488eb3.svg";
export { ForwardRef as ReactComponent };